import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatComponent } from './components/chat/chat.component';
import { ChatclientfinalComponent } from './components/chatclientfinal/chatclientfinal.component';
import { esnAbonneeGuard } from '@core/guards/esn-abonnee.guard';
import { clientFinalGuard } from '@core/guards/client-final.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'chat-list',
    pathMatch: 'full',
  },
  {
    path:'chat-list',
    component:ChatComponent,

  },
  {
    path:'chat-list-client',
    component:ChatclientfinalComponent,

  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatRoutingModule { }
